import React from 'react';
import { Col } from 'antd';

import LottieComponent from '../lottie-component';
import LottieFile from '@assets/lottiefiles';
import GifLoader from '@sharedComponent/gif-loader';

const AppLoader = ({ width = '10%', height = '10%' }) => {
	return (
		<Col style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
			{/* <LottieComponent file={LottieFile.Loading} width={width} height={height} /> */}
			<GifLoader />
		</Col>
	);
};

export default AppLoader;
